import {Select, TableSearchInput} from '@/components';
import type {AfriexQueryParams} from '@/types';

// What `Settings/Country/index.tsx` hands down out of `useCountryUpdate`.
// `clearFilters` is passed but not rendered by this component today.
type SettingsCountryFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
};

const SettingsCountryFilters = ({
  currentFilters,
  selectCurrentFilters,
  searchTerm,
  onSearchChange,
}: SettingsCountryFiltersProps) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-3">
        <TableSearchInput
          value={searchTerm}
          onChange={onSearchChange}
          placeholder="Search by name or code"
        />
        <Select
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            selectCurrentFilters('status', e.target.value)
          }
          value={currentFilters.status}
          name="status"
          options={[
            {
              key: 'Active',
              value: 'active',
            },
            {
              key: 'Not Active',
              value: 'inactive',
            },
          ]}
          placeholder="Filter by status"
        />
      </div>
    </div>
  );
};

export default SettingsCountryFilters;
